import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ModalWrapperComponent } from "./modal-wrapper.component";
import { MatIconModule } from "@angular/material/icon";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { SharedModule } from "@shared/shared.module";
import { FlexLayoutModule } from "ngx-flexible-layout";
import { MatLegacyTooltipModule as MatTooltipModule } from "@angular/material/legacy-tooltip";
import { MatGridListModule } from "@angular/material/grid-list";
import { InputSelectModule } from "../input-select/input-select.module";
import { ModalDropdownModule } from "./modal-dropdown/modal-dropdown.module";

@NgModule({
	declarations: [ModalWrapperComponent],
	imports: [
		CommonModule,
		MatIconModule,
		MatButtonModule,
		SharedModule,
		FlexLayoutModule,
		MatTooltipModule,
		MatGridListModule,
		InputSelectModule,
		ModalDropdownModule
	],
	exports: [ModalWrapperComponent]
})
export class ModalWrapperModule {}
